import React from "react";
import { Popover } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import { MonthCalendarItem } from "./pto-month-calendar";

const PtoMoreBox = (props) => {

    const moreListStyle = {
        width: 300,
        height: 400,
        positon: "absolute",
        backgroundColor: "white",
        marginLeft: -250,
        marginTop: -100,
        overflowY: "scroll",
        border: "2px solid #CCC",
        borderRadius: 5,
        padding: 10,
        boxShadow: "#666 0px 3px 5px"
    };

    const { items, count, dateKey, moreClass, employeeMap, itemProps, reserveSpace } = props
    return (
        count > 0 ?
            <div style={{ height: 25, width: "100%", flexGrow: 0 }}>
                <OverlayTrigger trigger="click" rootClose id={`ptomorebox_${dateKey}`} overlay={
                    <Popover id={`moreItems_${dateKey}`} className="pto-popover-hidden">
                        <div className="ap-vert-flex-container pto-popover-content" style={moreListStyle}>
                            {
                                items.map((item, idx) => {
                                    return <MonthCalendarItem key={`${dateKey}_${idx}`} showSingle {...itemProps} flexGrow={null} item={item} employee={employeeMap.get(item.peopleId)} />
                                })
                            }
                        </div>
                    </Popover>}>
                    <div className={`pto-more-box ap-clickable ${moreClass.join(" ")}`}>{count} more</div>
                </OverlayTrigger>
            </div> : 
            (reserveSpace ? <div style={{ height: 25, width: "100%", flexGrow: 0 }}></div> : null)
    );
}

export default PtoMoreBox;